import styled, { keyframes } from 'styled-components';

export const DefaultContainer = styled.div`
  margin: auto;
  width: 64px;
  height: 64px;
  margin-bottom: 1rem;
`;

const glowing = keyframes`
  from {
    filter: none;
  }

  to {

    filter: drop-shadow( 0 0 1px #48e2cb) drop-shadow( 0 0 1px #48e2cb) drop-shadow( 0 0 1px #48e2cb);
  }
`;

export const AnimationContainer = styled.div`
  margin: auto;
  width: 64px;
  height: 64px;
  margin-bottom: 1rem;
  animation: ${glowing} 1.5s ease-in-out infinite alternate;
`;
